module.exports = __webpack_public_path__ + "assets/img/esrb-en.0d48379f.png";